import { render } from "./BannerManager.vue?vue&type=template&id=2799547a"
import script from "./BannerManager.vue?vue&type=script&lang=js"
export * from "./BannerManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__